import { render, staticRenderFns } from "./BytesforslagDetail.vue?vue&type=template&id=348fd78f&scoped=true&"
import script from "./BytesforslagDetail.vue?vue&type=script&lang=js&"
export * from "./BytesforslagDetail.vue?vue&type=script&lang=js&"
import style0 from "./BytesforslagDetail.vue?vue&type=style&index=0&id=348fd78f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fd78f",
  null
  
)

export default component.exports